import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, Lock } from "lucide-react";
import { NAV_LINKS } from "./navConstants";

export function DesktopNav({ vereine, location, accentColor, isMemberLoggedIn, setActiveClub }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) setDropdownOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <nav className="hidden lg:flex items-center gap-5">
      {NAV_LINKS.map(link => (
        <Link key={link.path} to={link.path}
          data-testid={`nav-${link.path.replace('/', '') || 'home'}`}
          className={`text-sm font-medium uppercase tracking-wider transition-colors duration-200 ${location.pathname === link.path ? '' : 'text-muted-foreground hover:text-foreground'}`}
          style={location.pathname === link.path ? { color: accentColor } : {}}>
          {link.label}
        </Link>
      ))}
      <div className="relative" ref={dropdownRef}>
        <button onClick={() => setDropdownOpen(!dropdownOpen)}
          className="flex items-center gap-1 text-sm font-medium uppercase tracking-wider text-muted-foreground hover:text-foreground transition-colors"
          data-testid="nav-vereine-dropdown">
          Vereine & Mehr <ChevronDown className={`w-3.5 h-3.5 transition-transform ${dropdownOpen ? 'rotate-180' : ''}`} />
        </button>
        {dropdownOpen && (
          <div className="absolute right-0 top-full mt-2 w-56 bg-card border border-white/10 shadow-xl z-50 py-2" data-testid="vereine-dropdown-menu">
            <p className="px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-muted-foreground">Vereine</p>
            {vereine.map(club => (
              <Link key={club.id} to={`/club/${club.id}`}
                onClick={() => { setActiveClub(club.id); setDropdownOpen(false); }}
                className="flex items-center gap-2 px-4 py-2 text-sm text-muted-foreground hover:text-foreground hover:bg-white/[0.03] transition-colors"
                data-testid={`dropdown-club-${club.id}`}>
                <div className="w-2 h-2 rounded-full" style={{ backgroundColor: club.accent }} />
                {club.name}
              </Link>
            ))}
            <div className="border-t border-white/5 my-1" />
            <p className="px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-muted-foreground">Mehr</p>
            <Link to="/club/sportuebertragungen"
              onClick={() => { setActiveClub('sportuebertragungen'); setDropdownOpen(false); }}
              className="flex items-center gap-2 px-4 py-2 text-sm text-muted-foreground hover:text-foreground hover:bg-white/[0.03] transition-colors"
              data-testid="dropdown-sportuebertragungen">
              <div className="w-2 h-2 rounded-full bg-red-500" />
              Sportübertragungen
            </Link>
            <Link to="/ligaplatzierung"
              onClick={() => setDropdownOpen(false)}
              className="flex items-center gap-2 px-4 py-2 text-sm text-muted-foreground hover:text-foreground hover:bg-white/[0.03] transition-colors"
              data-testid="dropdown-ligaplatzierung">
              <div className="w-2 h-2 rounded-full bg-primary" />
              Ligaplatzierung
              {!isMemberLoggedIn && <Lock className="w-3 h-3 ml-auto text-muted-foreground" />}
            </Link>
            <Link to="/downloads"
              onClick={() => setDropdownOpen(false)}
              className="flex items-center gap-2 px-4 py-2 text-sm text-muted-foreground hover:text-foreground hover:bg-white/[0.03] transition-colors"
              data-testid="dropdown-downloads">
              <div className="w-2 h-2 rounded-full bg-primary" />
              Downloads
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}
